import { render, staticRenderFns } from "./RichTextAreaColorPicker.vue?vue&type=template&id=6ee624e3&scoped=true"
import script from "./RichTextAreaColorPicker.vue?vue&type=script&lang=js"
export * from "./RichTextAreaColorPicker.vue?vue&type=script&lang=js"
import style0 from "./RichTextAreaColorPicker.vue?vue&type=style&index=0&id=6ee624e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee624e3",
  null
  
)

export default component.exports